import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "caption-box" }
const _hoisted_2 = {
  key: 0,
  class: "captions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.captionText != null)
      ? (_openBlock(), _createBlock("text", _hoisted_2, _toDisplayString(_ctx.captionText), 1))
      : _createCommentVNode("", true)
  ]))
}